import EventManagerService from './EventManagerService';
import SecurityService from './SecurityService';
//@ts-ignore
export default new EventManagerService(SecurityService);